import { render, staticRenderFns } from "./NavigationMain.vue?vue&type=template&id=60e4d19e&"
import script from "./NavigationMain.vue?vue&type=script&lang=js&"
export * from "./NavigationMain.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports